import { convertCase } from "core/stringUtils";
import moment from "moment";
import TipoMotoboyEnum from "./entrega/tipo-motoboy.enum";
import { map } from "underscore";
import Inputmask from "inputmask";

const numberFormat = Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL"
});

moment.locale('pt-br');

function filiaisBuilder(res) {
  let response = { filiais: [] };

  if (!res.data) return response;

  response.filiais = []

  for (const key in res.data.filiaisComEstoque) {
    if (res.data.filiaisComEstoque.hasOwnProperty(key)) {
      const e = res.data.filiaisComEstoque[key];
        response.filiais.push({
          hoje: key,
          titulo: key == "true" ? "Retire Hoje" : "Próximas datas para retirada",
          dados: e ? Array.prototype.map.call(e, buildFilial) : null,
        })
    }
  }

  response.filiais = response.filiais.reverse();

  response.telefones = Array.prototype.map.call(
    res.data.telefones,
    buildTelefone
  );

  response.estados = map(res.data.estados, nome => {
    return {
      nome: nome,
      selected: nome == res.data.estadoSelecionado ? true : false
    };
  });

  response.cidades = map(res.data.cidades, nome => {
    return {
      nome: nome,
      selected: nome == res.data.cidadeSelecionado ? true : false
    };
  });

  response.bairros = map(res.data.bairros, nome => {
    return {
      nome: nome,
      selected: nome == res.data.bairroSelecionado ? true : false
    };
  });

  return response;
}

function buildFilial(filial) {
  let tituloModal = '';
  let builderEndereco = [];
  let builderHorario = [];
  let buildHorarioFormatado = [];
  let filialStatusClass = "filial-status-default";
  let dataEntrega = null;
  let enderecoCompleto = '';
  let horarioFormatado = '';
  let horarioParaReirada = '';
  let modalStatusFilial = null;
  let filialFechada = false;
  let {
    endereco,
    horarioAbertura,
    horarioFechamento,
    horarioAberturaFinalSemana,
    horarioFechamentoFinalSemana,
    dataEntregaCD,
    horarioProximaAbertura,
    statusFilial,
    filialFuncionaNoDia
  } = filial;

  const isWeekend = ([0,6].indexOf(new Date().getDay()) != -1);

  if(isWeekend) {
    if (horarioAberturaFinalSemana != null && horarioFechamentoFinalSemana != null) {
      horarioAbertura = horarioAberturaFinalSemana;
      horarioFechamento = horarioFechamentoFinalSemana;
    }
  }

  if (endereco) {
    if (endereco.nomeLogradouro)
      builderEndereco.push(
        endereco.tipoLogradouro
          ? `${endereco.tipoLogradouro}. ${endereco.nomeLogradouro}`
          : endereco.nomeLogradouro
      );
    if (endereco.numero) builderEndereco.push(endereco.numero);
    if (endereco.bairro) builderEndereco.push(endereco.bairro);
    if (endereco.cidade && endereco.siglaDaUF)
      builderEndereco.push(`${endereco.cidade}/${endereco.siglaDaUF}`);
    if (endereco.cep) builderEndereco.push(`CEP: ${endereco.cep}`);
    enderecoCompleto = convertCase(builderEndereco.join(", "));
  }

  if(dataEntregaCD != null){
    dataEntrega = moment(dataEntregaCD).calendar(null, {
      sameDay: '[em 30 minutos]',
      nextDay: 'dddd DD/MM',
      nextWeek: 'dddd DD/MM',
      sameElse: 'dddd DD/MM'
    })
  }

  if(statusFilial == "Aberta") {
    filialStatusClass = "filial-status-aberta";
  }

  if(statusFilial == "Fechada") {
    filialStatusClass = "filial-status-fechada";
    tituloModal = "Aviso de loja fechada";
    filialFechada = true;
  }

  if(statusFilial == "Em_Breve") {
    tituloModal = "Loja prestes a fechar";
  }

  if(statusFilial == "Em_Breve") {
    buildHorarioFormatado.push("Hoje até as ");
    buildHorarioFormatado.push(moment(horarioFechamento).format("HH:mm"));
    buildHorarioFormatado.push("h, ou amanhã a partir das ")
    if(horarioProximaAbertura != null){
      buildHorarioFormatado.push(moment(horarioProximaAbertura).format("HH:mm"));
    }else {
      buildHorarioFormatado.push(moment(horarioAbertura).format("HH:mm"));
    }
    buildHorarioFormatado.push("h")
    horarioParaReirada = buildHorarioFormatado.join(" ");
  }

  if(statusFilial == "Fechada") {
    if(horarioProximaAbertura != null){
      horarioParaReirada = moment(horarioProximaAbertura).calendar(null, {
        sameDay: '[A partir das ] HH:mm [h]',
        nextDay: '[Amanhã a partir das ] HH:mm [h]'
      })
    }else {
      horarioParaReirada = moment(horarioAbertura).calendar(null, {
        sameDay: '[A partir das ] HH:mm [h]',
        nextDay: '[Amanhã a partir das ] HH:mm [h]'
      })
    }
  }

  if(horarioAbertura && horarioFechamento) {
    builderHorario.push("Horário da loja:");
    builderHorario.push(moment(horarioAbertura).format("HH:mm"));
    builderHorario.push("às");
    builderHorario.push(moment(horarioFechamento).format("HH:mm"));
    horarioFormatado = builderHorario.join(" ");
  }

  if(statusFilial == "Fechada") {
    dataEntrega = "Fechada"
    modalStatusFilial = "Fechada"
  } else {
    modalStatusFilial = "Aberta"
  }

  return { ...filial, filialFuncionaNoDia, filialFechada, modalStatusFilial, enderecoCompleto, horarioFormatado, horarioParaReirada, filialStatusClass, horarioProximaAbertura,
    statusFilial, tituloModal, dataEntrega };
}

function pedidoBuilder(res) {
  if (!res.data) return res;

  if(res.data.pedido != null){
    if(res.data.pedido.entrega != null){
      if(res.data.pedido.entrega.horarioRetiradaBalcao != null){
        res.data.pedido.entrega.horarioRetiradaBalcao = moment(res.data.pedido.entrega.horarioRetiradaBalcao).format("DD/MM dddd")
      }
    }
  }

  let carrinho = [];
  let pedido = res.data.pedido || {};
  let { endereco, entrega, formaPagamento } = pedido;
  let builderEndereco = [];
  let entrega_selected = false;
  let pagamento_selected = false;
  let finalizar_pedido = false;
  pedido.cepEntrega = "";
  pedido.logradouroEntrega = "";
  pedido.numeroEntrega = "";
  pedido.rotaSelecionada = "";
  pedido.entregaTipo = "";

  if (endereco) {
    if (
      pedido.endereco.identificadorEndereco == null ||
      pedido.endereco.identificadorEndereco == ""
    )
      pedido.endereco.identificadorEndereco = "ENDEREÇO";
    if (endereco.logradouro)
      builderEndereco.push(
        endereco.logradouro.tipoLogradouro
          ? `${endereco.logradouro.tipoLogradouro}. ${endereco.logradouro.nome}`
          : endereco.logradouro.nome
      );
    if (endereco.numeroEndereco) builderEndereco.push(endereco.numeroEndereco);
    if (endereco.logradouro.bairro)
      builderEndereco.push(endereco.logradouro.bairro.nome);
    if (endereco.logradouro.bairro.localidade)
      builderEndereco.push(
        `${endereco.logradouro.bairro.localidade.nome}/${
          endereco.logradouro.bairro.localidade.siglaUf
        }`
      );
    if (endereco.logradouro != null && endereco.logradouro.cep != null) pedido.cepEntrega = endereco.logradouro.cep
    if (endereco.logradouro != null && endereco.logradouro.codigo != null) pedido.logradouroEntrega = endereco.logradouro.codigo
    if (endereco.numeroEndereco != null) pedido.numeroEntrega = endereco.numeroEndereco
  }

  let enderecoCompleto = convertCase(builderEndereco.join(", "));

  if (entrega != null && entrega.tipoEntrega != null) {
    pedido.entregaTipo = entrega.entregaTipo
    entrega_selected = true;

    if (entrega.valorTaxa == 0) entrega.fretegratis = true;

    entrega.valorTaxaNaoFormatado = entrega.valorTaxa;
    entrega.valorTaxa = numberFormat.format(entrega.valorTaxa);

    if (entrega.horarioRota != null) {
      entrega.programada = true;
      entrega.horarioRota = buildRotas(entrega.horarioRota);
      pedido.rotaSelecionada = entrega.horarioRota.dataInicial
    }
  }

  pedido.valorTotal = numberFormat.format(res.data.valorTotal);
  pedido.valorNaoContempladoFormatted = numberFormat.format(
    pedido.valorNaoContemplado
  );
  pedido.valorDesconto = numberFormat.format(res.data.valorDesconto);
  pedido.subTotal = numberFormat.format(res.data.subTotal);
  pedido.valorDescontoCupom = numberFormat.format(res.data.itens.filter(item => item.origemDesconto === 20).reduce((total, item) => {
    return total = total + item.valorDesconto
  }, 0));
  pedido.valorDescontoConvenio = numberFormat.format(res.data.itens.filter(item => item.origemDesconto === 3 || item.descontoConvenioVista).reduce((total, item) => {
    return total = total + item.valorDesconto
  }, 0));

  carrinho = carrinhoBuilder(
    res.data,
    entrega ? entrega.valorTaxaNaoFormatado : 0
  );

  carrinho.subTotal = pedido.subTotal
    ? numberFormat.format(pedido.subTotal)
    : numberFormat.format(0.0);
  carrinho.valorTotal = pedido.valorTotal
    ? numberFormat.format(pedido.valorTotal)
    : numberFormat.format(0.0);
  carrinho.valorDesconto = pedido.valorDesconto
    ? numberFormat.format(pedido.valorDesconto)
    : numberFormat.format(0.0);

  if (formaPagamento != null && formaPagamento.codigoFormaPagamento) {
    pagamento_selected = true;
    formaPagamento.segundaForma = false;

    if (
      pedido.tipoFormaPagamento == "CARTAO_CREDITO" ||
      pedido.tipoFormaPagamento == "CARTAO ONLINE A VISTA" ||
      pedido.tipoFormaPagamento == "CARTAO ONLINE PARCELADO"
    ) {
      formaPagamento.label = "Cartão de Crédito";
      formaPagamento.subDescription = `Quantidade de Parcelas: ${
        formaPagamento.cartaoCredito.quantidadeParcelas
      }`;
      formaPagamento.cvv = res.data.formaPagamento.cartaoCredito.cvv
    }
    if (pedido.tipoFormaPagamento == "CARTAO_POS") {
      formaPagamento.label = "Pagamento na Entrega";
      if (pedido.formaPagamento.codigoFormaPagamento == "42") formaPagamento.description = "Débito"
      if (pedido.formaPagamento.codigoFormaPagamento == "34" || pedido.formaPagamento.codigoFormaPagamento == "45") formaPagamento.description = "Crédito"
      if (pedido.formaPagamento.cartaoCredito.convenio.codigoConvenio == 358339) {
        formaPagamento.subDescription = "Banrisul"
      }
      if (pedido.formaPagamento.cartaoCredito.convenio.codigoConvenio == 439703) {
        formaPagamento.subDescription = "Elo"
      }
      if (pedido.formaPagamento.cartaoCredito.convenio.codigoConvenio == 441210) {
        formaPagamento.subDescription = "Maestro"
      }
      if (pedido.formaPagamento.cartaoCredito.convenio.codigoConvenio == 254525) {
        formaPagamento.subDescription = "Visa"
      }
      if (pedido.formaPagamento.cartaoCredito.convenio.codigoConvenio == 463434) {
        formaPagamento.subDescription = "American Express"
      }
      if (pedido.formaPagamento.cartaoCredito.convenio.codigoConvenio == 440213) {
        formaPagamento.subDescription = "Dinners"
      }
      if (pedido.formaPagamento.cartaoCredito.convenio.codigoConvenio == 439690) {
        formaPagamento.subDescription = "Mastercard"
      }
      if (pedido.formaPagamento.cartaoCredito.convenio.codigoConvenio == 473383) {
        formaPagamento.subDescription = "Auxílio Emergencial"
      }
    }
    if (pedido.tipoFormaPagamento == "DINHEIRO") {
      formaPagamento.label = "Pagamento na Entrega";
      formaPagamento.description = "Dinheiro";
      formaPagamento.subDescription = `Valor de Troco: ${numberFormat.format(
        pedido.valorTroco
      )}`;
    }
    if (pedido.tipoFormaPagamento == "BOLETO") {
      formaPagamento.label = "Pagamento com Boleto";
      formaPagamento.description = `Atenção: Boletos bancários não podem ser pagos com cheque.`;
    }
    if (pedido.tipoFormaPagamento == "RESGATE") {
      formaPagamento.label = "Resgate de Pontos";
      formaPagamento.description = `Valor utilizado: ${numberFormat.format(
        pedido.formaPagamento.resgate.valorUtilizado
      )}`;

      if (pedido.formaPagamento.resgate.formaPagamentoSecundaria != null) {
        formaPagamento.segundaForma = true;

        if (
          pedido.formaPagamento.resgate.formaPagamentoSecundaria
            .tipoFormaPagamento == "CARTAO_CREDITO"
        ) {
          formaPagamento.labelSegundaForma = "Pagamento Complementar com Cartão de Crédito";
          formaPagamento.descriptionSegundaForma = `Valor: ${numberFormat.format(
            pedido.formaPagamento.resgate.formaPagamentoSecundaria.valorFormaPagamentoSecundaria
          )}`;
        }
      }
    }
    if (pedido.tipoFormaPagamento == "CONVENIO_PRAZO") {
      pedido.convenioPrazo.valorContemplado = numberFormat.format(
        pedido.convenioPrazo.valorContemplado
      );
      pedido.convenioPrazo.valorNaoContemplado = numberFormat.format(
        pedido.convenioPrazo.valorNaoContemplado
      );

      formaPagamento.label = "Convênio Débito em Folha";
      formaPagamento.description = pedido.convenioPrazo.nomeConvenio;
      formaPagamento.subDescription = `Valor contemplado: ${
        pedido.convenioPrazo.valorContemplado
      }`;
    }
  }

  finalizar_pedido = entrega_selected && pagamento_selected;

  return {
    carrinho,
    pedido,
    enderecoCompleto,
    pagamento_selected,
    entrega_selected,
    finalizar_pedido
  };
}

function pedidoCartaoBuilder(res, cartaoCredito) {
  if (!res.data) return res;

  res.data.formaPagamento = {
    codigoFormaPagamento: null,
    cartaoCredito: {
      numero: null,
      numeroCartaoFormatado: null,
      numParcelas: null,
      cvv: null,
      expiry: null,
      name: null
    }
  };

  const number = cartaoCredito.number.split(" ");

  res.data.pagamentoCartaoCredito = true;
  res.data.formaPagamento.codigoFormaPagamento = 51;
  res.data.formaPagamento.cartaoCredito.numero = cartaoCredito.number;
  res.data.formaPagamento.cartaoCredito.numeroCartaoFormatado = `${
    cartaoCredito.type
  } terminado em: ${number[number.length - 1]}`;
  res.data.formaPagamento.cartaoCredito.numParcelas = cartaoCredito.parcelas;
  res.data.formaPagamento.cartaoCredito.expiry = cartaoCredito.expiry;
  res.data.formaPagamento.cartaoCredito.cvc = cartaoCredito.cvc;
  res.data.formaPagamento.cartaoCredito.name = cartaoCredito.name;
  res.data.formaPagamento.cartaoCredito.quantidadeParcelas =
    cartaoCredito.quantidadeParcelas;
  res.data.tipoFormaPagamento = "CARTAO ONLINE A VISTA";

  return pedidoBuilder(res);
}

function pedidoCartaoOnlineBuilder(res, cartaoCredito) {
  if (!res.data) return res;

  res.data.formaPagamento = {
    codigoFormaPagamento: null,
    cartaoCredito: {
      numParcelas: null
    }
  };

  res.data.pagamentoCartaoCredito = true;
  res.data.formaPagamento.codigoFormaPagamento = res.data.pedido.formaPagamento.codigoFormaPagamento;
  res.data.formaPagamento.cartaoCredito.numParcelas = cartaoCredito.quantidadeParcelas;
  res.data.formaPagamento.cartaoCredito.cvv = cartaoCredito.cvc

  return pedidoBuilder(res);
}

function verificaOrigemCartao(res, cartaoCredito) {
  if (res.data.pedido.formaPagamento.cartaoCredito != null && res.data.pedido.formaPagamento.cartaoCredito.cardHash != null) {
    return pedidoCartaoOnlineBuilder(res, cartaoCredito)
  } else {
    return pedidoCartaoBuilder(res, cartaoCredito)
  }
}

function carrinhoBuilder(carrinho, valorTaxa) {
  let presenteavel = []
  carrinho.assinaturas = carrinho.assinaturas || [];
  if (valorTaxa == null || valorTaxa == "") valorTaxa = 0;

  for (var key in carrinho.assinaturas) {
    carrinho.assinaturas[key] = {
      valorTotal: numberFormat.format(carrinho.assinaturas[key] + valorTaxa),
      periodo: key
    };
  }

  for (let i = 0; i < carrinho.itens.length; i++) {
    if (carrinho.itens[i].presenteavel) {
      presenteavel.push(carrinho.itens[i])
    }
  }
  
  return {
    presenteavel: presenteavel.length > 0,
    vitrinesChaordic: carrinho.vitrinesChaordic,
    possuiRestricaoEntrega: carrinho.possuiRestricaoEntrega,
    possuiControladoComToken: carrinho.possuiControladoComToken,
    possuiControladoSemToken: carrinho.possuiControladoSemToken,
    possuiItemComRetencaoReceita: (carrinho.possuiControladoComToken || carrinho.possuiControladoSemToken),
    examePanvel: carrinho.examePanvel,
    vacina: carrinho.vacina,
    exameLaboratorio: carrinho.exameLaboratorio,
    diaEntregaAssinatura: carrinho.diaEntregaAssinatura,
    diaFaturamentoAssinatura: carrinho.diaFaturamentoAssinatura,
    possuiAssinatura: Object.keys(carrinho.assinaturas).length > 0,
    possuiRestricaoReceitaEletronica: carrinho.possuiRestricaoReceitaEletronica,
    possuiItemNaoPermiteToken: carrinho.possuiItemNaoPermiteToken,
    habilitaProdutosSemRestricao: carrinho.habilitaProdutosSemRestricao,
    itensAssinaturaCompra: carrinho.assinaturas == null ? [] : carrinho.assinaturas,
    possuiItemSemEstoque: carrinho.possuiItemSemEstoque,
    possuiItemSemRestricao: carrinho.possuiItemSemRestricao,
    itensCarrinhoCompra:
      carrinho.itens == null
        ? []
        : carrinho.itens.map(item => {
            if (item.assinaturaItemDetalhe != null)
              item.assinaturaItemDetalhe.periodo =
                item.assinaturaItemDetalhe.mesPeriodo <= 1
                  ? `${item.assinaturaItemDetalhe.mesPeriodo} Mês`
                  : `${item.assinaturaItemDetalhe.mesPeriodo} Meses`;

            return {
              codigo: item.codigo ? item.codigo : item.codigoPack,
              nome: item.nome,
              valorDesconto: numberFormat.format(item.valorDesconto),
              valorPorUnitarioFloat: item.valorPorUnitario,
              valorPorUnitario: numberFormat.format(item.valorPorUnitario),
              valorPorTotal: numberFormat.format(item.valorPorTotal),
              valorDeUnitario: numberFormat.format(item.valorDeUnitario),
              percentualDesconto: item.percentualDesconto,
              existePercentualDesconto: (item.percentualDesconto != null && item.percentualDesconto > 0),
              mostrarDesconto: buildMostrarDesconto(item),
              quantidade: item.quantidade,
              imagem: buildImagemItem(item.imagensDetalhe),
              imagemReduzida: buildImagemItem(item.imagensDetalhe, 0),
              classeSelo: item.classeSelo,
              descricaoSelo: item.descricaoSelo,
              mostrarDePor: item.mostrarDePor,
              tipoSelo: item.tipoSelo,
              urlItem: item.urlItem,
              erro: verificaEstoque(item),
              disponivel: verificaDisponibilidade(item),
              tipoDisponibilidade: item.tipoDisponibilidade,
              itemGeladeira: item.tipoDisponibilidade == "GELADEIRA_VENDA_N_PERMITIDA",
              mensagemDisponibilidade: item.mensagemDisponibilidade,
              estoque: item.estoque,
              assinaturaItemDetalhe: item.assinaturaItemDetalhe,
              codigoFabricante: item.codigoFabricante,
              promocaoAssinatura: item.promocaoAssinatura,
              itemAssinavel: item.itemAssinavel,
              cupom: item.origemDesconto == 20,
              convenio: item.descontoConvenioVista,
              pack: item.origemDesconto == 18,
              pbm: item.origemDesconto == 5,
              bemPanvel: item.bemPanvel != null ? item.bemPanvel : false,
              permiteToken: item.permiteToken,
              tokenReceita: item.tokenReceita,
              retencaoReceita: item.retencaoReceita,
              exameLaboratorio: item.exameLaboratorio  != null ? item.exameLaboratorio : false,
              examePanvel: item.examePanvel  != null ? item.examePanvel : false,
              vacina: item.vacina  != null ? item.vacina : false,
              isGesture: item.codigo == 827340 ? true : false
            };
          })
  };
}

function verificaDisponibilidade(item) {
  return item.tipoDisponibilidade == "ITEM_SEM_ESTOQUE"
    ? false
    : true;
}

function verificaEstoque(item) {
  return item.tipoDisponibilidade != null && item.tipoDisponibilidade != ""
    ? true
    : false;
}

function buildMostrarDesconto(item) {
  if (item.codigoPack) return false;

  return item.percentualDesconto != null && item.mostrarDePor == true;
}

function buildImagemItem(imagensDetalhe, size = 3) {
  if (
    imagensDetalhe == null ||
    imagensDetalhe.length == 0 ||
    imagensDetalhe[0].length == 0
  )
    return null;

  return imagensDetalhe[0][size];
}

function lockersBuilder(res) {
  let response = { lockers: [] };

  if (!res.data) return response;

  response.lockers = map(res.data.lockersComEstoque, buildLocker);
  response.telefones = Array.prototype.map.call(
    res.data.telefones,
    buildTelefone
  );
  response.estados = map(res.data.estados, nome => {
    return {
      nome: nome,
      selected: nome == res.data.estadoSelecionado ? true : false
    };
  });
  response.cidades = map(res.data.cidades, nome => {
    return {
      nome: nome,
      selected: nome == res.data.cidadeSelecionado ? true : false
    };
  });
  response.bairros = map(res.data.bairros, nome => {
    return {
      nome: nome,
      selected: nome == res.data.bairroSelecionado ? true : false
    };
  });

  return response;
}

function buildLocker(locker) {
  let builderEndereco = [];
  let { endereco } = locker;
  let locker20 = false;

  if (endereco) {
    if (endereco.nomeLogradouro)
      builderEndereco.push(
        endereco.tipoLogradouro
          ? `${endereco.tipoLogradouro}. ${endereco.nomeLogradouro}`
          : endereco.nomeLogradouro
      );
    if (endereco.numero) builderEndereco.push(endereco.numero);
    if (endereco.nomeBairro) builderEndereco.push(endereco.nomeBairro);
    if (endereco.nomeLocalidade && endereco.uf)
      builderEndereco.push(`${endereco.nomeLocalidade}/${endereco.uf}`);
    if (endereco.cep) builderEndereco.push(`CEP: ${endereco.cep}`);
  }

  let enderecoCompleto = convertCase(builderEndereco.join(", "));

  locker20 = locker.idLocker == 20 || locker.idLocker == "20"

  return { ...locker, enderecoCompleto, locker20 };
}

function enderecosBuilder(res) {
  let response = { enderecos: [] };

  if (!res.data) return response;

  response.enderecos = Array.prototype.map.call(res.data, buildEndereco);

  return response;
}

function buildEndereco(endereco) {
  let builderEndereco = [];

  if (endereco.identificadorEndereco == null || endereco.identificadorEndereco == "") endereco.identificadorEndereco = `${endereco.tipoDeLogradouro}. ${endereco.nomeDoLogradouro}`;
  if (endereco.tipoDeLogradouro) builderEndereco.push(endereco.tipoDeLogradouro ? `${endereco.tipoDeLogradouro}. ${endereco.nomeDoLogradouro}` : endereco.nomeDoLogradouro );
  if (endereco.numeroDeEndereco) builderEndereco.push(endereco.numeroDeEndereco);
  if (endereco.nomeDoBairro) builderEndereco.push(endereco.nomeDoBairro);
  if (endereco.nomeDaLocalidade && endereco.siglaDaUF) builderEndereco.push(`${endereco.nomeDaLocalidade}/${endereco.siglaDaUF}`);
  if (endereco.cep) builderEndereco.push(`CEP: ${endereco.cep}`);

  let enderecoCompleto = convertCase(builderEndereco.join(", "));

  return { ...endereco, enderecoCompleto };
}

function tiposEntregaBuilder(res) {

  let response = { tiposEntrega: [] };

  if (!res.data) return response;

  response.tiposEntregaCompleta = Array.prototype.map.call(
    res.data.formasEntregaCestaCompleta.sort((a, b) => a.valorFrete - b.valorFrete),
    buildEntrega
  );
  response.tiposEntregaParcial = Array.prototype.map.call(
    res.data.formasEntregaCestaParcial.sort((a, b) => a.valorFrete - b.valorFrete),
    buildEntrega
  );
  let entregaCorreios = Array.prototype.filter.call(
    response.tiposEntrega,
    (el) => el.codigoTipoDeEntrega == 2 || el.codigoTipoDeEntrega == 4
  );
  response.exibeAvisoAtraso = (entregaCorreios && entregaCorreios.length > 0) ? true : false;
  response.existeFormaEntrega = ((response.tiposEntregaCompleta && response.tiposEntregaCompleta.length > 0) || (response.tiposEntregaParcial && response.tiposEntregaParcial.length > 0)) ? true : false;
  response.existeFormaEntrega =  true;
  response.telefones = Array.prototype.map.call(
    res.data.telefones,
    buildTelefone
  );

  response.horarioProgramadaSelecionado = res.horarioProgramadaSelecionado

  return response;
}

function buildEntrega(entrega) {
  let fretegratis = false;
  let valorFrete = numberFormat.format(0);
  let programada = entrega.horarioRota != null && entrega.horarioRota.length > 0 ? true : false;

  if (programada) map(entrega.horarioRota, buildRotas);
  if (entrega.valorFrete == 0) fretegratis = true;
  if (entrega.valorFrete != 0) valorFrete = numberFormat.format(entrega.valorFrete);
  if(entrega.dataProximaAbertura) entrega.dataProximaAbertura = moment(entrega.dataProximaAbertura).format("DD/MM");

  return { ...entrega, fretegratis, valorFrete, programada };
}

function buildTelefone(telefone) {
  const size = telefone.telefone.toString().length;
  const telefoneFormatado = `(${
    telefone.ddd
  }) ${telefone.telefone
    .toString()
    .substr(0, size == 9 ? 5 : 4)}-${telefone.telefone
    .toString()
    .substr(size == 9 ? 5 : 4, size == 9 ? 8 : 7)}`;

  return { ...telefone, telefoneFormatado };
}

function buildRotas(rota) {
  moment.locale('pt-br');
  const dataAtual = moment();
  const dataInicial = moment(rota.dataInicial);
  const dataFinal = moment(rota.dataFinal);

  rota.periodo = dataInicial.format('DD/MM dddd');

  if (dataInicial.hour() >= 8 && dataInicial.hour() < 13) {
    rota.turno = ` de manhã das ${dataInicial.hour()}h às ${dataFinal.hour()}h`;
  } else if (dataInicial.hour() >= 13 && dataInicial.hour() < 18) {
    rota.turno = ` à tarde das ${dataInicial.hour()}h às ${dataFinal.hour()}h`;
  } else {
    rota.turno = ` à noite das ${dataInicial.hour()}h às ${dataFinal.hour()}h`;
  }

  return rota;
}

function cartaoCreditoBuilder(res) {
  let response = { parcelas: [] };

  if (!res.data) return response;

  response.parcelas = Array.prototype.map.call(res.data, buildParcela);
  response.cartaoOnlineLiberado = res.data[0].cartaoOnlineLiberado

  return response;
}

function buildParcela(parcela) {
  let resumoParcela = `${parcela.quantidadeParcelas} X ${numberFormat.format(
    parcela.valorParcela
  )}`;

  return { ...parcela, resumoParcela };
}

function cartaoCreditoOnlineBuilder(res) {
  let response = { parcelas: [] };

  if (!res.data) return response;

  let listaParcelas = []

  buildListaParcelas(listaParcelas, res.data.parcelaVistaResponse)
  buildListaParcelas(listaParcelas, res.data.parcelaPrazoResponse)

  response.parcelas = Array.prototype.map.call(listaParcelas, buildParcela);

  return response;
}

function buildListaParcelas(listaParcelas, parcelas) {
  if (parcelas != null && parcelas.length > 0) {
    for (let i=0; i < parcelas.length; i++) {
      listaParcelas.push(parcelas[i])
    }
  }
}

function buildParcela(parcela) {
  let resumoParcela = `${parcela.quantidadeParcelas} X ${numberFormat.format(
    parcela.valorParcela
  )}`;

  return { ...parcela, resumoParcela };
}

function formasPagamentoBuilder(res, shouldResetPayment, origemPagamento) {
  let response = { tipos: [] };

  if (!res.data) return response;

  response.tipos = Array.prototype.map.call(
    res.data.formasPagamentoDisponiveis,
    buildFormaPagamento
  );

  response.possuiAssinatura = res.data.possuiAssinatura;
  response.limparPagamento = shouldResetPayment;
  response.habilitaPagueOnline = false;
  response.habilitaPos = false;
  response.habilitaDinheiro = false;

  if (res.data.habilitaPos != null && res.data.habilitaPos) response.habilitaPagueOnline = true
  if (res.data.habilitaDinheiro != null && res.data.habilitaDinheiro) response.habilitaPagueOnline = true
  if (res.data.habilitaPos != null && res.data.habilitaPos) response.habilitaPos = true
  if (res.data.habilitaDinheiro != null && res.data.habilitaDinheiro) response.habilitaDinheiro = true
  if (origemPagamento != null && origemPagamento != '') response.origemPagamento = origemPagamento

  return response;
}

function buildFormaPagamento(forma) {
  //["DINHEIRO","RESGATE FIDELIDADE","CONVENIO","CARTAO ONLINE A VISTA","CARTAO ONLINE PARCELADO","BOLETO BANCARIO"]
  let obj = {
    rotulo: forma
  };

  if (forma.toString() == "DINHEIRO") obj.dinheiro = true;
  if (forma.toString() == "RESGATE FIDELIDADE") obj.resgate = true;
  if (forma.toString() == "CARTAO ONLINE A VISTA") obj.cartao = true;
  if (forma.toString() == "BOLETO BANCARIO") obj.boleto = true;
  if (forma.toString() == "CONVENIO") obj.convenio = true;

  return obj;
}

function convenioBuilder(res, request) {
  if (!res.data) return res;

  let response = res.data;

  response.necessitaSegundaFormaPagamento =
    response.valorNaoContemplado != null &&
    response.valorNaoContemplado != "" &&
    response.valorNaoContemplado > 0
      ? true
      : false;
  response.valorContemplado = numberFormat.format(response.valorContemplado);
  response.valorNaoContemplado = numberFormat.format(
    response.valorNaoContemplado
  );
  response.valorTaxaEntrega = numberFormat.format(response.valorTaxaEntrega);

  return { ...request, ...response };
}

function cartoesBuilder(res) {
  let response = { cartoes: [] };

  if (!res.data) return response;

  if (res.data != null) {
    let possuiCartaoPrincipal = false
    for (let i=0; i < res.data.length; i++) {
      let cartaoPrincipal = false;
      if (res.data[i].cartaoPrincipal == 'S') {
        cartaoPrincipal = true;
        possuiCartaoPrincipal = true;
      }
      let cartao = {
        vencimento: res.data[i].mesAnoVencimento,
        numero: res.data[i].numeroCartao,
        autorizadora: res.data[i].nomeAutorizadora,
        final: res.data[i].numeroCartao.substr(12, 4),
        idCartao: res.data[i].idCartao,
        hashCartao: res.data[i].hashCartao,
        codigoConvenio: res.data[i].codigoConvenio,
        idAutorizadora: res.data[i].idAutorizadora,
        cartaoPrincipal: cartaoPrincipal
      }
      response.cartoes.push(cartao)
    }
    response.possuiCartaoPrincipal = possuiCartaoPrincipal
  }
  return response
}

function bandeirasPosBuilder(res, tipoPagamento) {
  let response = { bandeiras: [] };
  let bandeiras = null
  if (tipoPagamento == 'CARTAO_CREDITO_POS') {
    bandeiras = res.data.formasPagamentoCredito
    response.credito = true
    response.debito = false
  }
  if (tipoPagamento == 'CARTAO_DEBITO_POS') {
    bandeiras = res.data.formasPagamentoDebito
    response.debito = true
    response.credito = false
  }
  if (bandeiras != null) {
    bandeiras.forEach((bandeira) => {
      if (bandeira.codigoConvenio == 358339) {
        bandeira.banrisul = true
      }
      if (bandeira.codigoConvenio == 439703) {
        bandeira.elo = true
      }
      if (bandeira.codigoConvenio == 441210) {
        bandeira.maestro = true
      }
      if (bandeira.codigoConvenio == 254525) {
        bandeira.visa = true
      }
      if (bandeira.codigoConvenio == 463434) {
        bandeira.americanExpress = true
      }
      if (bandeira.codigoConvenio == 440213) {
        bandeira.dinners = true
      }
      if (bandeira.codigoConvenio == 439690) {
        bandeira.mastercard = true
      }
      if (bandeira.codigoConvenio == 473383) {
        bandeira.auxilio = true
      }
      bandeira.codigoConvenio = bandeira.codigoConvenio
      bandeira.codigoFormaPagamentoParcelado = bandeira.codigoFormaPagamentoParcelado
      bandeira.codigoFormaPagamentoVista = bandeira.codigoFormaPagamentoVista
    })
  }
  response.bandeiras = bandeiras
  return response;
}

export {
  filiaisBuilder,
  pedidoBuilder,
  lockersBuilder,
  enderecosBuilder,
  tiposEntregaBuilder,
  cartaoCreditoBuilder,
  cartaoCreditoOnlineBuilder,
  formasPagamentoBuilder,
  verificaOrigemCartao,
  convenioBuilder,
  cartoesBuilder,
  bandeirasPosBuilder
};



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/pages/checkout/checkout.builder.js